export const NOMADS_LAND_URL =
  "https://open.spotify.com/intl-fr/artist/4Akyx2MoKYCpiFKub8L8xB";

export const MATHIEU_PHOTO_URL = "/photo-mathieu.jpg";

export const CLEMENT_PHOTO_URL = "/photo-clement.jpg";

export const Tournons_la_page_URL =
  "https://www.tournonslapage.org/";

export const CLEMENT_BIO =
  "Clément s’est forgé une solide connaissance politique de manière autodidacte. C’est en animant de nombreuses formations de la Fresque du climat qu’il sent naître une passion : approfondir des sujets politiques complexes, et les rendre accessibles et compréhensibles pour le plus grand nombre. Candidat aux élections législatives de 2022 pour s'immerger dans les rouages d'une campagne électorale et en décrypter les dynamiques, il a développé une expertise pointue en analyse de discours politiques et de jeux de pouvoirs.";
